import { Stack, Heading } from 'braid-design-system';
import React from 'react';
import Youtube from 'react-youtube';

import Section from 'src/views/Franchise/components/Section/Section';

import * as styles from './style.css';

const FranchiseeStories = () => (
  <Section>
    <Stack space="medium">
      <Heading level="2">Franchisee stories</Heading>
      <div className={styles.container}>
        <Youtube
          videoId="u4gc2zOtq5I"
          opts={{ height: '100%', width: '100%' }}
          className={styles.iframe}
        />
      </div>
    </Stack>
  </Section>
);

export default FranchiseeStories;
